"use strict";

// if(typeof svg4everybody == 'function') {
//   svg4everybody();
// }

window.isSafari = false;
var userAgent = navigator.userAgent.toLowerCase();
if (userAgent.indexOf('safari') != -1) {
	if (userAgent.indexOf('chrome') > -1) {
		window.isSafari = false;
	} else {
		window.isSafari = true;
	}
};

if(navigator.userAgent.match(/Trident\/7\./)) { // if IE
	$('body').on("mousewheel", function (event) {
			// remove default behavior
			event.preventDefault();

			//scroll without smoothing
			var wheelDelta = event.wheelDelta;
			var currentScrollPosition = window.pageYOffset;
			window.scrollTo(0, currentScrollPosition - wheelDelta);
	});
}

var
parseDate = function(timestamp) {
	var _date = new Date();

	_date.setTime(timestamp * 1000);

	var hours = _date.getHours(),
		minutes = _date.getMinutes(),
		day = ('0' + _date.getDate()).slice(-2),
		month = ('0' + (_date.getMonth() + 1)).slice(-2),
		year = _date.getFullYear();
	return day + "." + month + "." + year;
},

navbarAffix = function() {
	var _navbar = $('.navbar'),
		_navbarBrand = $('.navbar .navbar-brand');
	if ( window.innerWidth > 767 ) {
		// _navbar.hide();
		$(window).on('scroll resize onload', function() {
			var _scrollTop = parseInt($(window).scrollTop());
			if (_scrollTop > ($('header').height())) {
				_navbar.addClass('affix');
			} else {
				_navbar.removeClass('affix');
				$('.dropdown-menu').dropdown('hide');
			}
		});
	} else {
		// _navbar.show();
		// $(window).on('scroll resize', function() {
		// 	var _scrollTop = parseInt($(window).scrollTop());
		// 	_navbarBrand.stop(true);
		// 	if (_scrollTop > ($('header').height())) {
		// 		_navbarBrand.css({opacity: 1});
		// 	} else {
		// 		_navbarBrand.css({opacity: 0});
		// 	}
		// });
	}
},
// Навигация по якорям
scrollCatalog = function (id, delay){
	var
		idOffsetTop = Math.round( $(id).offset().top ),
		bodyOffsetTop = $('body').offset().top,
		// paddingTop = ( window.innerWidth <= 767 )? 65 : 5,
		paddingTop = 0,
		sectionMenuTitleHeight = ( $(id).find('.section__menu-title').length )? $(id).find('.section__menu-title').height() : 0,
		_headerHeight = ( $('.header').length )? $('.header').outerHeight(true) : 0,
		_navbarHeight = ( $('.navbar').length )? $('.navbar').outerHeight(true) : 0,
		selectShopWrapHeight = ( $('.select-shop_wrap').length )? $('.select-shop_wrap').height() : 0,
		smartbannerHeight = ( $('#smartbanner').length )? $('#smartbanner').height() : 0,
		$chScrollPositions = Math.round( idOffsetTop - paddingTop + _headerHeight - selectShopWrapHeight - sectionMenuTitleHeight );

	if (delay) { delay = 300; };

	if($('[role="tab"][href="'+ id +'"]').length > 0) {
		var _parentId = $(id).parents('.tab-pane').attr('id');
		if (_parentId !== undefined) {
			$('[href="#'+ _parentId +'"]').tab('show');
		}
		$('[href="'+ id +'"]').tab('show');
		var _tabList = parseInt( $('[role="tab"][href="'+ id +'"]').parents('.tabs__nav').outerHeight(true) );
		paddingTop = (($(id).hasClass('tab-pane'))? (( window.innerWidth > 767 ) ? (_tabList + 44) : 5 ) : 0);
	}

	$('html,body').delay(delay)
		.animate({
			// scrollTop: $chScrollPositions
			scrollTop: Math.round( $(id).offset().top - 55 - paddingTop )
		}, 400, 'swing');

	if( !$('.navbar .navbar-toggler').hasClass('collapsed') ){
		$('.navbar .navbar-toggler').addClass('collapsed');
		$('.navbar-collapse').collapse('hide');
	}

	return true;
},

isInViewport = function(elem) {
	var
		docViewTop = $(window).scrollTop(),
		docViewBottom = docViewTop + $(window).height(),
		elemTop = $(elem).offset().top,
		elemBottom = elemTop + $(elem).height();
	return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
},

trackGAEvent = function(category, label, action){
  action = (typeof action === "undefined") ? 'click' : action;
  if (typeof ga !== "undefined") {
    ga('send', 'event', category, action, label, { 'hitCallback': function(){} });
  }
  // console.log('trackGAEvent', label);
  return true;
},
trackOutboundLink = function(url){
	trackGAEvent('outbound', url);
},

reachGoal = function(_ID, _TARGET){
  if (typeof ym !== "undefined") {
    ym(_ID, 'reachGoal', _TARGET);
  }
  // console.log('reachGoal', _TARGET);
  return true;
},

goals = function($this) {
	var
		_ymid = $this.data('ymid'),
		_ymt = $this.data('ymt'),
		_gac = $this.data('gacategory'),
		_gal = $this.data('galabel');
	if (typeof _ymt === "undefined") {} else {
		reachGoal(_ymid, _ymt);
		console.log('reachGoal',_ymt);
	}
	if (typeof _gal === "undefined") {} else {
		trackGAEvent(_gac, _gal);
		console.log('trackGAEvent',_gal);
	}
}

;(function() {

	if ( $('[data-href]').length > 0 ) {
		$('[data-href]').each(function(){
			var self = $(this),
				href = self.attr('data-href');

			self.attr('href',href).attr('target','_blank').attr('rel','nofollow');
		})
	}

	$('._goals')
		.not('form')
		.on('click', function(){
			return goals($(this));
		});

	$('form._goals')
		.on('submit', function(){
			return goals($(this));
		});

	// $('body').scrollspy({
	//   target: '#navbarSupportedContent',
	//   offset: 60
	// });

	function mainRedirect() {
		window.location.href = "/";
	}

	if ( $('.page-404').length ) {
		setTimeout(mainRedirect, 4000);
	}

	// if ( $('[data-inputmask]').length > 0) {
	// 	$("[data-inputmask]").inputmask("+7(999)999-99-99");
	// }

	if ( $('.alert-success').length > 0) {
		setTimeout(function(){
			$('.alert-success').fadeOut('slow');
		}, 7000);
	}

	navbarAffix();
	$(window).on('resize', function(){ navbarAffix(); });

	// ### Навигация по якорям // Скролл по хэшу в урле
	var hashData = document.location.hash;
	if ( hashData ) {
		scroll(0,0);
	}

	if ( $(hashData).length > 0 ) {
		// scrollCatalog(hashData);
		$.when( scrollCatalog(hashData) ).done(function(){
			document.location.hash = hashData;
			// document.location.hash = '#';
		});
	}

	$('[role="tab"]').on('click', function(){
		var _id = $(this).attr('href'),
			_parentId = $(_id).parents('.tab-pane').attr('id');

		if(!window.isSafari) {
			document.location.hash = _id;
		}

		if (_parentId == undefined) {
			if ( window.innerWidth <= 767 ) {
				scrollCatalog(_id);
			}
		}
	});

	$('.navbar-nav .nav-link, .navbar-nav .dropdown-item')
		.not('.dropdown-toggle')
		// .on('click touchstart', function (e){
		.on('click', function (e){
			var self = $(this),
				href = (self.attr('href')).split('#')[1],
				id = '#' + href;

			$('.navbar-collapse').collapse('hide');
			$('.dropdown-menu').dropdown('hide');

			if ( $(id).length > 0 ) {
				e.preventDefault();

				// Скролл к цели и закрыть навигацию
				$.when( scrollCatalog(id) ).done(function(){
					document.location.hash = href;
					// document.location.hash = '#';
				});

				return false;
			} else {
				return true;
			};
		});

  // if(typeof $.lazyload == 'function') {
  //   if ($('[data-lazyload]').length > 0) {
  //   	$('img[data-lazyload="true"],img[data-lazyload="1"]').lazyload();
  //   }
  // }

})();